import { createContext } from 'react';

export interface IMediaContext {
  screen: 'Desktop' | 'Mobile';
}

export const MediaContext = createContext<IMediaContext>({ screen: 'Desktop' });
